import PropTypes from 'prop-types'
import { LineChart, Line, XAxis, YAxis, ResponsiveContainer } from 'recharts'

const ColoredDot = ({ cx, cy, index }) => {
  const COLORS = ['#0080c7', '#467925', '#faac18', '#aebc36', '#992663']

  const color = COLORS[index % 5]

  return (
    <svg x={cx - 8} y={cy - 8} width={16} height={16} fill={color} viewBox="0 0 16 16">
      <path d="M8.338 14.857c4.09 0 7.405-3.323 7.405-7.422 0-4.1-3.316-7.423-7.405-7.423C4.248.012.933 3.336.933 7.435c0 4.1 3.316 7.422 7.405 7.422" />
    </svg>
  )
}

ColoredDot.propTypes = {
  cx: PropTypes.number,
  cy: PropTypes.number,
  index: PropTypes.number,
}

function App({ data }) {
  return (
    <>
      <ResponsiveContainer width="100%" height="100%">
        <LineChart
          width={500}
          height={500}
          data={data}
          margin={{
            top: 20,
            right: 50,
            left: 20,
            bottom: 20,
          }}
        >
          <XAxis dataKey="name" />
          <YAxis
            unit="M"
            domain={['dataMin - 20', 'dataMax']}
            scale="linear"
            tickCount={5}
            tickFormatter={(value) => `$${value}`}
          />
          <Line type="linear" dataKey="value" stroke="#939597" strokeWidth={2} dot={<ColoredDot />} />
        </LineChart>
      </ResponsiveContainer>
    </>
  )
}

App.propTypes = {
  data: PropTypes.array,
}

export default App
